import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../Store';
import { redirectPerformed } from '../../Store/Redirect/action';
import { useHistory } from 'react-router-dom';

const Redirect: React.FC = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const redirect = useSelector<RootState, string | null>(state => state.redirect.url);

    useEffect(() => {
        if (redirect !== null) {
            dispatch(redirectPerformed());
            if (redirect.includes('https')) {
                window.location.href = redirect;
                return;
            }

            history.push(redirect);
        }
    });

    return null;
};

export default Redirect;
